import { FC, HTMLProps } from 'react';

export const FeedbacksIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.00648 5.00686C5.08708 5.00231 5.16827 5 5.25 5H15.75C18.0972 5 20 6.90279 20 9.25V11.4982C20.5409 11.7237 21.0447 12.0202 21.5 12.3761V9.25C21.5 6.07436 18.9256 3.5 15.75 3.5H7.74996C6.59644 3.5 5.58328 4.10095 5.00648 5.00686ZM19 9.25V11.1739C18.5185 11.0602 18.0163 11 17.5 11V9.25C17.5 8.2835 16.7165 7.5 15.75 7.5H5.25C4.2835 7.5 3.5 8.2835 3.5 9.25V15.75C3.5 16.7165 4.2835 17.5 5.25 17.5H6.5V20.2582L10.2559 17.5H11C11 18.0163 11.0602 18.5185 11.1739 19H10.7475L6.98989 21.7595C6.16433 22.3657 5 21.7762 5 20.752V18.9905C3.32189 18.8629 2 17.4608 2 15.75V9.25C2 7.45507 3.45507 6 5.25 6H15.75C17.5449 6 19 7.45507 19 9.25ZM23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12C20.5376 12 23 14.4624 23 17.5ZM20.8536 15.1464C20.6583 14.9512 20.3417 14.9512 20.1464 15.1464L16.5 18.7929L14.8536 17.1464C14.6583 16.9512 14.3417 16.9512 14.1464 17.1464C13.9512 17.3417 13.9512 17.6583 14.1464 17.8536L16.1464 19.8536C16.3417 20.0488 16.6583 20.0488 16.8536 19.8536L20.8536 15.8536C21.0488 15.6583 21.0488 15.3417 20.8536 15.1464Z"
        fill="currentColor"
      />
    </svg>
  );
};
